/**@description The base types of pay which do not include Holiday or Unpaid time */
export enum PayrollTypeBaseEnum {
  Straight = 's',
  Overtime = 'o',
  Double = 'd',
}

/**@description The complete list of pay types */
export enum PayrollTypeFullEnum {
  Straight = 's',
  Overtime = 'o',
  Double = 'd',
  Holiday = 'h',
  Unpaid = 'u',
}

/**@description All the possible statuses for a Timesheet if any additional statuses are added, we will need to review logic particularly around approval to make sure it conforms to a hierarchy*/
export enum TimesheetStatusEnum {
  Created = 'CR',
  InProgress = 'IP',
  PayrollApproved = 'PA',
  BillingApproved = 'BA',
  Error = 'ER',
}

/**@description The scope the records are being sent from, if on billing screen, or payroll. In case of Foreman, always payroll */
export enum ModificationContextEnum {
  Payroll = 'payroll',
  Billing = 'billing',
}
